import React, { useEffect, useRef, useState } from "react";
 
interface SignupProps {
  isOpenAlert: boolean;
  onClose: () => void;
  onParentClose: () => void; // New prop to close the parent modal
}
 
function SignupAlert({ isOpenAlert, onClose, onParentClose }: SignupProps) {
  const modalRef = useRef<HTMLDivElement>(null);
 
  const closeModalAlert = () => {
    onClose();
    onParentClose(); // Call the parent close callback
  };
 
  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose();
      onParentClose(); // Call the parent close callback
    }
  };
 
  useEffect(() => {
    if (isOpenAlert) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
 
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenAlert]);
 
  if (!isOpenAlert) return null;
 
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div
          className="bg-white w-full max-w-md p-8 rounded-lg shadow-lg relative"
          ref={modalRef}
        >
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
            onClick={closeModalAlert}
          >
            ✖
          </button>
          <h2 className="text-2xl font-bold text-pink-600 text-center">
            Thanks for signing up!
          </h2>
          <p className="text-center mt-4 text-gray-700">
            Our support team will reach out to you for further assistance.
          </p>
        </div>
      </div>
    </>
  );
}
 
export default SignupAlert;
 